import { Suspense } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ApplyHero from './components/ApplyHero';
import ApplicationForm from './components/ApplicationForm';

export default function ApplyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ContactPage",
        "@id": `${siteUrl}/apply`,
        "name": "Apply for a Bottleneck Audit | Force Multiplier",
        "description": "Apply for a comprehensive bottleneck audit to identify and remove structural constraints limiting your company's growth.",
        "url": `${siteUrl}/apply`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "Force Multiplier",
          "url": siteUrl
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Apply",
            "item": `${siteUrl}/apply`
          }
        ]
      }
    ]
  };

  return (
    <Suspense fallback={<div className="min-h-screen bg-black" />}>
      <SEOHead
        title="Apply for a Bottleneck Audit | Force Multiplier"
        description="Apply for a comprehensive bottleneck audit to identify and remove structural constraints limiting your company's growth. Strategic advisory for founder-led companies."
        canonicalPath="/apply"
        schema={schema}
      />
      <div className="relative min-h-screen bg-black text-white overflow-hidden">
        <Navigation />
        <ApplyHero />
        <ApplicationForm />
        <Footer />
      </div>
    </Suspense>
  );
}